import { Button } from '@creditornot/cb-button';
import { ImageStack } from '@creditornot/cb-icons';
import { color } from '@creditornot/cb-ingredients/design-tokens';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';
import { OnboardingPopover } from 'modules/shared-menu/components/Onboarding/OnboardingPopover';
import { useOfferingMenuPermissionsContext } from 'modules/shared-menu/contexts/OfferingMenuPermissionsContext';
import { useListingManagerRoutes } from 'modules/shared-menu/hooks/useListingManagerRoutes';
import { useListingManagerImageGalleryFeatureFlag } from 'modules/shared-menu/pages/ListingManagerImageGalleryPage/hooks/useListingManagerImageGalleryFeatureFlag';

import { SingleVenueActions } from './SingleVenueActions';
import { CentralisedAddButton } from '../../SharedMenuPage/components/CentralisedAddButton';

const Root = styled.div`
  display: flex;
  padding: 24px;
  border-block-end: 1px solid ${color.border};
  justify-content: space-between;
  align-items: end;
`;

const SelectionHeader = styled(T.Heading4)`
  display: flex;
  flex-direction: column;
`;

const SelectionNameAndStatus = styled.div`
  display: flex;
  align-items: center;
`;

const SelectionActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const SingleVenueHeader = () => {
  const history = useHistory();
  const menuPermissions = useOfferingMenuPermissionsContext();
  const { isListingManagerImageGalleryEnabled } = useListingManagerImageGalleryFeatureFlag();
  const { menuEditorImageGalleryBrowseImagesPage } = useListingManagerRoutes();

  return (
    <Root>
      <SelectionHeader>
        <SelectionNameAndStatus>
          <FormattedMessage id="menu.menu-sync.status-header" />
        </SelectionNameAndStatus>
      </SelectionHeader>
      <SelectionActionsContainer>
        {menuPermissions.contentEdit && <SingleVenueActions />}
        {isListingManagerImageGalleryEnabled && (
          <Button
            variant="secondary"
            icon={<ImageStack />}
            size="small"
            onClick={() => history.push(menuEditorImageGalleryBrowseImagesPage())}
          >
            <FormattedMessage id="shared-menu.editor.image-gallery.button-label" />
          </Button>
        )}
        {menuPermissions.contentEdit && (
          <OnboardingPopover placement="bottom-end" step="ONBOARDING_STEP_4_CREATE">
            <CentralisedAddButton />
          </OnboardingPopover>
        )}
      </SelectionActionsContainer>
    </Root>
  );
};
